import SocialButton from "./socialButton";

const SocialLogin: React.FC<{ hostname: string }> = ({ hostname }) => {
  return (
    <div className="mt-6 flex w-full items-start gap-3 whitespace-nowrap text-sm leading-none">
      <SocialButton
        icon={`https://${hostname}/rio/public/images/google-ico.svg`}
        label="Google"
      />
      <SocialButton
        icon={`https://${hostname}/rio/public/images/linkedin.svg`}
        label="LinkedIn"
      />
    </div>
  );
};

export default SocialLogin;
